export default "__VITE_PUBLIC_ASSET__f76d985c__"